
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80","viewBox":"0 0 96 96"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"rgba(0,0,0,0)","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5"}},[_c('path',{attrs:{"d":"M71.977 28.669a2.424 2.424 0 00-.761 0 10.35 10.35 0 11.761 0z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M67.852 57.817c5.486.92 11.532-.04 15.78-2.88 5.646-3.764 5.646-9.93 0-13.694-4.288-2.845-10.415-3.806-15.9-2.845"}})]),_c('g',{attrs:{"data-name":"Group","fill":"rgba(0,0,0,0)","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5"}},[_c('path',{attrs:{"data-name":"Vector","d":"M23.904 28.669a2.424 2.424 0 01.761 0 10.35 10.35 0 10-.761 0zM28.028 57.817c-5.486.92-11.532-.04-15.776-2.88-5.646-3.764-5.646-9.93 0-13.694 4.284-2.845 10.411-3.806 15.896-2.845"}})]),_c('g',{attrs:{"data-name":"Group","fill":"rgba(0,0,0,0)","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5"}},[_c('path',{attrs:{"data-name":"Vector","d":"M48 58.483a2.424 2.424 0 00-.761 0 10.35 10.35 0 11.761 0zM36.348 71.095c-5.646 3.764-5.646 9.93 0 13.694 6.406 4.284 16.9 4.284 23.3 0 5.646-3.764 5.646-9.93 0-13.694-6.363-4.244-16.893-4.244-23.3 0z"}})])])
          )
        }
      }
    